var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBank = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.109 15.337c1.914 0 2.891-.957 2.891-2.853V2.853C20 .967 19.023 0 17.109 0H2.89C.967 0 0 .957 0 2.853v9.631c0 1.896.967 2.853 2.891 2.853H17.11zM18.42 3.715H1.58v-.757c0-.919.488-1.388 1.369-1.388H17.05c.871 0 1.37.47 1.37 1.388v.757zm-1.369 10.052H2.95c-.881 0-1.37-.469-1.37-1.388V5.792H18.42v6.587c0 .92-.498 1.388-1.369 1.388zM6.223 11.154c.536 0 .89-.364.89-.872V8.607c0-.507-.354-.871-.89-.871H4.002c-.527 0-.89.364-.89.871v1.675c0 .508.363.872.89.872h2.221z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBank, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/_bank.39c0227a.svg";
export { ForwardRef as ReactComponent };